import React from 'react'
// routes
import { PATH_DOCS, PATH_PAGE } from '../routes/paths'
// components
import { PATH_AFTER_LOGIN, siteData } from '../config'
// components
import Iconify from '../components/Iconify'

// ----------------------------------------------------------------------

const ICON_SIZE = {
	width: 22,
	height: 22,
}

export const universalMenuConfig = [
	{
		title: 'World',
		icon: <Iconify icon="eva:home-fill" {...ICON_SIZE} />,
		path: '/',
	},
	{
		title: 'About',
		icon: <Iconify icon="eva:info-fill" {...ICON_SIZE} />,
		path: PATH_PAGE.about,
	},
	{
		title: 'More',
		path: '/pages',
		icon: <Iconify icon="eva:more-horizontal-fill" {...ICON_SIZE} />,
		children: [
			{
				subheader: 'FAQs & Docs',
				items: [
					// { title: 'For Creators', path: siteData.partnershipForm, target: '_blank' },
					{ title: 'White Paper', path: siteData.whitepaper, target: '_blank' },
					{ title: 'Creator FAQs', path: siteData.wikiForCreators, target: '_blank' },
					{ title: 'Collector FAQs', path: siteData.wikiForCollectors, target: '_blank' },
				],
			},
			{
				subheader: 'Contact',
				items: [

					{ title: 'Twitter', path: siteData.twitterPage, target: '_blank' },
					// { title: 'Telegram', path: siteData.telegramPage, target: '_blank' },
					{ title: 'Email', path: PATH_PAGE.contact },
				],
			},
			{
				subheader: 'Company',
				items: [
					{ title: 'Team & Investors', path: PATH_PAGE.team },
					{ title: 'Terms of Service', path: PATH_PAGE.tos },
					{ title: 'Privacy Policy', path: PATH_PAGE.privacy },
				],
			},
		],
	},
	/* {
		title: 'Documentation',
		icon: <Iconify icon="eva:book-open-fill" {...ICON_SIZE} />,
		path: PATH_DOCS,
	}, */
]
